// extracted by mini-css-extract-plugin
module.exports = {"paginationBtns":"paginateUsers_paginationBtns__2-q0O","paginationActive":"paginateUsers_paginationActive__1fi82"};